import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
  produtos: []
});

class ProdutosStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.LIST_PRODUCTS_FINISH:
                return state.set('produtos', action.produtos);

            default:
                return state;
        }
    }
}

export default new ProdutosStore();



// WEBPACK FOOTER //
// src/stores/ProdutosStore.js